import FlashcardComponent from '@views/quizzes/flashcards/show';
import FlashcardV2Component from '@views/quizzes/flashcards-v2/show';
import ProgressFlashcardComponent from '@views/progress/questions/show';

export default [
  {
    path: '/quizzes',
    name: 'quizzes#index',
    component: () => import(/* webpackChunkName: "quizzes/index" */ '@views/quizzes/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/quizzes/create/show',
    name: 'quizzes#create',
    component: () => import(/* webpackChunkName: "quizzes/create" */ '@views/quizzes/create'),
    meta: {
      header: true,
    },
  },
  {
    path: '/quizzes/:categoryId/flashcards/:flashcardId?',
    name: 'quizzes#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/quizzes/:categoryId/flashcards-v2/:flashcardId?',
    name: 'quizzes#flashcard-v2',
    component: FlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/quizzes/:categoryId/results',
    name: 'quizzes#results',
    component: () => import(/* webpackChunkName: "quizzes/results" */ '@views/quizzes/results'),
    meta: {
      header: true,
    },
  },
  {
    path: '/quizzes/:categoryId/results/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'quizzes#results#question',
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
];
